import { render, staticRenderFns } from "./App.vue?vue&type=template&id=e920d152&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e920d152')) {
      api.createRecord('e920d152', component.options)
    } else {
      api.reload('e920d152', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=e920d152&", function () {
      api.rerender('e920d152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App.vue"
export default component.exports